export default __webpack_public_path__ + "static/media/964.931c94e1.jpg";